enum ETabStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  DEFAULT = 'default',
}

export default ETabStatus;
